export default __webpack_public_path__ + "static/media/here_to_help.1313cbd9.jpg";